<template>
    <div class="con-box">
        <el-row>

            <el-col :span="4">
                <el-card class="box-card">
                    <el-row class="question-index-box">
                        <el-col :span="24">
                            <div class="question-number-title">
                                题目编号
                            </div>
                        </el-col>
                        <el-col  v-for="(item, index) in question_map" :key="index" :span="6" style="padding:0">
                                <div :class="[selectQuestionIndex == index ? 'now-select-btn' : '', 'question-index-btn', item.selectedOption.length != 0 ? 'complete-index-btn' : ''] "  @click="checkQuestion(item,index)">
                                    {{index+1}}
                                </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="question-number-submit-btn-box">
                                <div class="submit-btn"  @click="submit()">
                                    提交
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :span="12">
                <div class="work-name-box"  v-if="selectQuestionIndex === index" v-for="(item, index) in question_map" :key="index">
                    <el-card :class="['header-box', item.category_id == 5 || item.category_id == 6 ? 'work-box-card' : '', 'box-card' ] ">
                        <div slot="header" class="clearfix">
                            <div class="work-name">
                                {{base_data.work_name}}
                            </div>
                            <div v-if="timeShow" class="time-show">
                                剩余时间:{{remainingTimeText}}
                            </div>
                        </div>
                        <div>
                            <el-row class="question-box">
                                <div >
             
                                    <el-col :span="24">
                                        <div class="question-index">
                                            <span>{{index + 1}} </span>、 <span class="category-name">（{{item.category_name}}） </span>
                                        </div>
                                        <div class="" v-html="item.title">
                                            
                                        </div>
                                    </el-col>
                                    <el-col  :span="24" v-if="item.audio_resources_url != ''" class="question-source">
                                        <audio controls height="100" width="100">
                                            <source :src="source_prefix+item.audio_resources_url" type="audio/mpeg">
                                        </audio>
                                    </el-col>
                                </div >
                            </el-row>
                        </div>
                    </el-card>
                    <div  v-if="selectQuestionIndex === index" v-for="(item, index) in question_map" :key="index">
                        <el-card class="box-card" v-if=" item.category_id != 5 && item.category_id != 6 ">
                            <div>
                                <el-row class="answer-option-box">
                                    <el-col :span="24" class="option-box" >
                                        <template>
                                            <div class="answer-title">
                                                答题区
                                            </div>
                                    
                                            <div  v-for="(o_item, o_index) in item.option_data" :key="o_index" class="option-item" @click="selectOption(o_item, index, item)">
                                                <div :class="[ (getOptionData(item.selectedOption).indexOf(o_item.option_guid ) >= 0)  ? 'selected-option' : '' ]">
                                                    <span style="padding-left:20px">
                                                        {{String.fromCharCode(65 + o_index)}}  | 
                                                    </span>
                                                    <span style="padding-left:10px">
                                                        {{o_item.content}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="item.category_id == 4">
                                                <el-row class="paixu-box">
                                                    <el-col :span="4">
                                                        <div class="paixu-text">我的答案：</div> 
                                                    </el-col>
                                                    <el-col :span="20">
                                                        <div class="selected-option-box">
                                                            <el-row v-if="item.selectedOption.length != 0" style="margin-top:0">
                                                                <el-col :span="20">
                                                                    <span v-for="(u_item, u_index) in item.selectedOption" :key="u_index">
                                                                        <span v-for="(o_item, o_index) in item.option_data" :key="o_index">
                                                                            <span v-if="u_item.option_guid == o_item.option_guid">
                                                                                {{String.fromCharCode(65 + o_index)}}
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </el-col>
                                                                <el-col :span="4">
                                                                    <i class="el-icon-delete clear-options" @click="clearOptions(item)"></i>
                                                                </el-col>
                                                            </el-row>
                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                        </template>
                                    </el-col>
                                   
                                </el-row>

                                <el-col :span="24">
                                    <div style="margin-top: 40px">
                                        <el-col style="text-align: center" v-if="selectQuestionIndex == 0">
                                        <el-button size="small" type="primary"  @click="next">下一题</el-button>
                                        </el-col>
                                        <el-col style="text-align: center" v-else-if="selectQuestionIndex == questionTotalCnt-1">
                                        <el-button size="small" type="primary"  @click="last">上一题</el-button>
                                        <el-button size="small" type="warning" style="margin-left: 30px" @click="submit()">提交</el-button>
                                        </el-col>
                                        <el-col style="text-align: center" v-else>
                                        <el-button size="small" type="primary"  @click="last">上一题</el-button>
                                        <el-button size="small" type="primary" style="margin-left: 30px" @click="next">下一题</el-button>
                                        </el-col>
                                    </div>
                                </el-col>

                            </div>

                        </el-card>
                    </div>
    
                </div>


            </el-col>
            <el-col :span="8">
                <el-row>
                    <el-col :span="23">
                        <div class="right-show-box">
                            <div class="right-show-content">
                                <div class="right-show-item">
                                    <div class="right-show-item-num">{{selectQuestionIndex +1 }} / {{question_map.length}}</div>
                                    <div class="right-show-item-title">总进度</div>
                                </div>
                                <div class="right-show-item">
                                    <div class="right-show-item-num">{{question_map.length !== 0 ? question_map[selectQuestionIndex].score : 0}}</div>
                                    <div class="right-show-item-title">当前题目分数</div>
                                </div>
                                <!-- <div class="right-show-item">
                                    <div class="right-show-item-num">1</div>
                                    <div class="right-show-item-title">已完成</div>
                                </div> -->
                            </div>
             
                        </div>

                        <div v-if="selectQuestionIndex === index" v-for="(item, index) in question_map" :key="index">
                            <el-card class="box-card" v-if=" item.category_id == 5 || item.category_id == 6 ">
                                <div>
                                    <el-row  class="answer-option-box">
                                        <div>
                                            <el-col>
                                                <div class="answer-title">
                                                    答题区
                                                </div>
                                            </el-col>
                                            <el-col :span="24" class="right-option-box" >
                                                <template>
                                                    <van-tabs>
                                                            <div v-for="(s_item,s_index) in item.son_question_data" :key="s_index" class="">
                                                                <van-tab :title="'第'+parseInt(s_index+1)+'题'">
                                                                    <div class="r-s-question-box">
                                                                        <van-row v-html="s_item.title"></van-row>
                                                                        <template>
                                                                            <div  v-for="(s_o_item, s_o_index) in s_item.option_data" :key="s_o_index" class="r-option-item" @click="selectOption(s_o_item, s_index, s_item, item)">
                                                                                <div :class="[ (getOptionData(s_item.selectedOption).indexOf(s_o_item.option_guid ) >= 0)  ? 'selected-option' : '' ]">

                                                                                    <span style="padding-left:20px">
                                                                                        {{String.fromCharCode(65 + s_o_index)}}  | 
                                                                                    </span>
                                                                                    <span style="padding-left:10px">
                                                                                        {{s_o_item.content}}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </van-tab>
                                                            </div>
                                                    </van-tabs>
                                                </template>
                                            </el-col>
                                        </div>
                                    </el-row>

                                    <el-col :span="24">
                                        <div style="margin-top: 40px">
                                            <el-col style="text-align: center" v-if="selectQuestionIndex == 0">
                                            <el-button size="small" type="primary"  @click="next">下一题</el-button>
                                            </el-col>
                                            <el-col style="text-align: center" v-else-if="selectQuestionIndex == questionTotalCnt-1">
                                            <el-button size="small" type="primary"  @click="last">上一题</el-button>
                                            <el-button size="small" type="warning" style="margin-left: 30px" @click="submit()">提交</el-button>
                                            </el-col>
                                            <el-col style="text-align: center" v-else>
                                            <el-button size="small" type="primary"  @click="last">上一题</el-button>
                                            <el-button size="small" type="primary" style="margin-left: 30px" @click="next">下一题</el-button>
                                            </el-col>
                                        </div>
                                    </el-col>

                                </div>

                            </el-card>
                        </div>




                    </el-col>
                    <el-col :span="1"></el-col>
                </el-row>
           
            </el-col>


        </el-row>

    </div>
</template>


<script>
    import { getAbilityEvaluationQuestions, homeworkDetail, submitAbilityEvaluationAnswer, recordStuAnswer, clearHomework, resetAbilityEvaluationRecord} from '@/api'
    import store from '@/store'
    export default {
        name: 'Home',
        props: ['cate', 'words'],
        data() {
            return {
                form:{
                    work_guid:""
                },
                base_data:{

                },
                question_map:[],
                selectQuestionIndex: 0,
                questionTotalCnt:0,
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
                answerData: {
                    difficult_level:0,
                    work_guid: '',
                    complete_flag: 'Y',
                    use_time: 0,
                    answer_data: []
                },
                submitType :true,
                activeData:{},
                timeShow:false,
                use_time:0,
                totalTime:0,
                remainingTime:1800,
                remainingTimeText:"",
                intervalId:0,
                needConfirm:true,
                confirmFlag:false,
                submitCompleteFlag:false

            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            gethomeworkDetail()
            {

                
                // resetAbilityEvaluationRecord(this.form).then(response => {

                // })

                getAbilityEvaluationQuestions(this.form).then(response => {

                    this.base_data = response.base_data
                    this.question_map = response.question_map
                    this.questionTotalCnt = this.question_map.length
                    for (const index in response.question_map) {
                        this.question_map[index].selectedOption = []
                        if(this.question_map[index].son_question_data.length != 0)
                        {
                            for (const s_index in this.question_map[index].son_question_data) {
                                this.question_map[index].son_question_data[s_index].selectedOption = []
                            }
                        }
                    }
                })

                // var formData = {
                //     where: {
                //         work_guid: this.form.work_guid
                //     }
                // }

                // homeworkDetail(formData).then(response => {
                //     this.base_data = response.base_data
                //     this.question_map = response.question_map
                //     this.questionTotalCnt = this.question_map.length
                //     for (const index in response.question_map) {
                //         this.question_map[index].selectedOption = []
                //         if(this.question_map[index].son_question_data.length != 0)
                //         {
                //             for (const s_index in this.question_map[index].son_question_data) {
                //                 this.question_map[index].son_question_data[s_index].selectedOption = []
                //             }
                //         }
                //     }
                // })
            },
            checkQuestion(e,index)
            {
                this.selectQuestionIndex = index
            },
      
            selectOption(item, index, q_item, p_q_item)
            {
                if(p_q_item != undefined)
                {
                    p_q_item.selectedOption = [1];
                }

                if(this.getOptionData(q_item.selectedOption).indexOf(item.option_guid) >= 0)
                {
                    return
                }

                if(q_item.category_id !== 4)
                {
                    q_item.selectedOption = [];
                }
                        
                q_item.selectedOption.push(item)
                this.$forceUpdate()
            },
            clearOptions(q_item){
                q_item.selectedOption = [];
                this.$forceUpdate()
            },
            getOptionData(data)
            {
                var arr = [];
                for (const index in data) {
                    arr.push(data[index].option_guid)
                }
                return arr
            },
            next() {
                this.selectQuestionIndex++;
            },
            last() {
                this.selectQuestionIndex--;
            },
            submit() {
                
   
                if(this.needConfirm)
                {
                    this.$confirm('确定要提交本次答案?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        this.confirmFlag = true
                        this.submitAnswer()
                
                    }).catch(() => {
                        this.$notify.info({
                        title: '信息提示',
                        message: '已取消此操作',
                        duration: 3000
                        })

                        this.confirmFlag = false
                    })
                }
                this.submitAnswer()

            },
            submitAnswer(){
                if(this.confirmFlag || !this.needConfirm){
                    // 提交遮罩层
                    var loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                        });
                        setTimeout(() => {
                        loading.close();
                    }, 10000);

                    var that = this

                    if(this.submitType){
                        this.submitType = false
                        var formData = {
                            work_guid : this.activeData.source_guid
                        }
                            clearHomework(formData).then(response => {
                                var answerData = [];
                                for (const key in this.question_map) {

                      


                                    if(this.question_map[key].son_question_data.length == 0)
                                    {
                                        var row  = {
                                            parent_guid: this.question_map[key].parent_guid,
                                            question_guid: this.question_map[key].question_guid,
                                            category_id: this.question_map[key].category_id,
                                            option_data: this.question_map[key].selectedOption
                                        }
                                        answerData.push(row)
                                    }
                    
                                    if(this.question_map[key].son_question_data.length != 0)
                                    {
                                        for (const s_index in this.question_map[key].son_question_data) {

                                            var s_parent_guid = this.question_map[key].son_question_data[s_index].parent_guid ?? ""
                                            var category_id = this.question_map[key].son_question_data[s_index].category_id ?? 5
                                            var srow = {
                                              
                                                parent_guid: s_parent_guid,
                                                question_guid: this.question_map[key].son_question_data[s_index].question_guid,
                                                category_id: category_id,
                                                option_data: this.question_map[key].son_question_data[s_index].selectedOption
                                            }

                                            answerData.push(srow)

                                        }
                                    }
                                }

                        
                                this.answerData.work_guid =  this.form.work_guid
                                this.answerData.use_time =  this.use_time
                                this.answerData.answer_data = answerData
   
                                submitAbilityEvaluationAnswer(this.answerData).then(response => {
                                    loading.close();
                                    this.$notify.success({
                                        title: '信息提示',
                                        message: '提交成功',
                                        duration: 3000
                                    })
                                    this.submitCompleteFlag = true
                                    this.$router.push({path:'/active/activeshow'})
                                })
                            })
                        }

                }
            },
            convertTimestamp(timestamp) {
                var seconds = Math.floor(timestamp);
                var hours = Math.floor(seconds / 3600);
                var minutes = Math.floor((seconds % 3600) / 60);
                var seconds = seconds % 60;

                hours = hours < 10 ? '0' + hours : hours;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                seconds = seconds < 10 ? '0' + seconds : seconds;
                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            },
            timeCheck(){
                var timeData = this.convertTimestamp(this.remainingTime)
                this.remainingTimeText = timeData.hours + ":" + timeData.minutes + ":" + timeData.seconds

                if(this.remainingTime == 0){
                    // 清除定时器
                    clearInterval(this.intervalId);
                    // 自动提交试题答案

                    this.needConfirm = false
                    this.submit()
                }
                else
                {
                    this.remainingTime = this.remainingTime - 1
                    this.use_time = this.use_time + 1
                }
            },
            handleBeforeUnload(event) {

                if(!this.submitCompleteFlag){
                  // 兼容火狐的做法
                    event.preventDefault()
                    event.returnValue = ''
                    // 展示提示消息 
                    // （这里其实修改默认提示语是不生效的，不过我的业务场景不需要修改默认提示语
                    // 我也没找到能修改的方法，有大佬知道的话麻烦告知）
                    const message = '确定要离开吗？'
                    event.returnValue = message
                    return message
                }
    
            },
            onPopState(e) {
                // 监听到浏览器回退事件（这里提示用的confirm，是可以自定义的）

                if(!this.submitCompleteFlag){
                    if (confirm('离开当前页面数据可能会丢失，您确定离开当前页面吗？')) {
                        // 点击确定回退
                        window.removeEventListener('popstate', this.onPopState)
                        window.history.go(-1)
                    } else {
                        // 点击取消不回退
                        window.history.pushState(null, null, window.location.href)
                    }
                }
                else{
                    window.removeEventListener('popstate', this.onPopState)
                }
        
            },


        },
        beforeDestroy() {
            // 清除定时器
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
        },
 
        destroyed(){
            window.removeEventListener('beforeunload', this.handleBeforeUnload)
            window.removeEventListener('unload', this.handleBeforeUnload)
             // 在组件销毁前，移除 popstate 事件监听
        window.removeEventListener('popstate', this.onPopState)
        },
        mounted() {

            var that = this
            this.form.work_guid = this.$route.query.work_guid
            this.answerData.work_guid = this.$route.query.work_guid
            this.gethomeworkDetail()

            store.dispatch('common/loadActiveData');
            
            if(store.state.common.activeData !== undefined && store.state.common.activeData != {} ){
                this.activeData = store.state.common.activeData

                if(this.activeData.active_guid !== undefined && this.activeData.active_guid == this.form.work_guid){
                    this.timeShow = true
                    this.remainingTime = this.activeData.duration

                    this.intervalId = setInterval(() => {
                        that.timeCheck()
                    }, 1000); // 每1000毫秒执行一次

                }

            }

            //

            window.addEventListener('beforeunload', this.handleBeforeUnload)
            window.addEventListener('unload', this.handleBeforeUnload)

            // 添加 popstate 事件监听
            window.history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', this.onPopState);

        

    

   
        }
    }
</script>
<style scoped lang="less">

    .header-box{
        position: relative;
    }

    .time-show{
        position: absolute;
        top: 20px;
        right: 30px;
        color:#F56C6C;
    }


    .right-show-item{
        display: flex;
        flex-flow: column;
        width:50%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .right-show-item-num{
        margin-bottom:15px;
        font-size:18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        opacity: 1;
    }

    .right-show-item-title{
        font-size:14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        opacity: 1;
    }

    .right-show-content{
        display: flex;
        flex-flow: wrap;
        width: 100%;
        background: -webkit-linear-gradient(#A5E8FF  ,#4B82F2); /* safari 5.1 - 6.0 */
        background: -o-linear-gradient(#A5E8FF , #4B82F2); /* opera 11.1 - 12.0 */
        background: -moz-linear-gradient(#A5E8FF , #4B82F2); /* firefox 3.6 - 15 */
        background: linear-gradient(#A5E8FF , #4B82F2); /* 标准的语法 */

   
        opacity: 0.8;
        border-radius: 16px;
        padding: 40px 15px;
    }
    .right-show-box{
        margin-top:20px;
        margin-bottom: 20px;
        background: #90FFBA;
        opacity: 0.5;

        border-radius: 16px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    .answer-title{
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2B2B2B;
    }
    .submit-btn{
        background: linear-gradient(90deg, #409EFF 0%, #A6E9FF 100%);
        box-shadow: 0px 4px 10px 0px rgba(165,231,255,0.75), 0px 10px 36px 0px rgba(144,204,255,0.85);
        border-radius: 24px;
        color:#fff;
        font-family: Source Han Sans CN;
        font-weight: 500;
        width:80%;
        margin:0 auto;
        padding: 10px 0 ;
    }
    .work-name-box{
        margin-top:20px;

    }

    .work-box-card{
        height: 91vh;
        overflow-y: scroll;
    }

    .paixu-box{
        height:40px;
        line-height:40px;
        margin-top:20px;
    }
    .clear-options{
        cursor: pointer;
        color:#F56C6C;
    }

    .selected-option-box{
        width:15vw;
        height:40px;
        line-height:40px;
        border: 1px solid #eee;
        box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.04) 0px 0px 6px;
        padding:0 20px;
    }
    

    .work-name{
        text-align: center;
        margin-top:20px;
        font-size:22px;
    }

    .question-index{
        text-align: left;
        padding-bottom:5px;
    }
    
    .question-box{
        padding:3vh 1vw;
    }

    .question-index-box{
        padding:0 0 0 0;
        min-height: 85vh;
        position: relative;
    }
    .question-index-btn{
        margin-bottom:10px;
        border-radius: 70px;
        text-align: center;
        height: 5vh;
        line-height: 5vh;
        width: 5vh;
        cursor: pointer;
        border: 1px solid #dcdfe6;
    }
    .option-box{
        margin-top:3vh;
        margin-left: 2vw;
    }

    .right-option-box{
        
    }
    .question-source{
        margin-top:1vh;
        padding-left:1vw;
    }

    .option-item{
        min-height: 3.5vh;
        line-height:3.5vh;
        margin-top:2vh;
        width: 25vw;
        background: #fff;
        cursor: pointer;
        border: 1px solid #BFBFBF;
        border-radius: 30px;
    }
    .r-option-item{
        min-height: 3.5vh;
        line-height:3.5vh;
        margin-top:2vh;
        background: #fff;
        cursor: pointer;
        border: 1px solid #BFBFBF;
        border-radius: 30px;
        padding:3px 5px;
    }
    .question-index-box .now-select-btn{
        background-color: #409EFF;
        color:#fff;
    }
    .complete-index-btn{
        background-color: #67C23A;
        color:#fff;
        
    }
     .selected-option{
        color: #409EFF;
        border-radius: 30px;
    }
    .category-name{
        color:#409EFF;
    }
    .s-question-box{
        padding-left:4vw;
        margin-top:2vh;
    }
    .r-s-question-box{
        margin-top:2vh;
    }




    .user-level{
        padding:20px 10px 20px 20px;
    }
    .con-box {
        padding: 0 0;
        background-color: #F5F7FA;
    }
    .box-card{
        margin:0 10px 20px 10px;
        padding:20px;
    }
    .learn-count{
        color:#666;
        text-align: right;
    }
    .btn-box{
        text-align: right;
    }

    .content-card {
        margin-top:10px;
    }
    .card-top{
        margin-bottom:10px;
    }

    .site-content {
        .notify {
            margin: 60px 0;
            border-radius: 3px;
            & > div {
                padding: 20px;
            }
        }


        .search-result {
            padding: 15px 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            border: 1px dashed #ddd;
            color: #828282;
        }
    }

    .top-feature {
        width: 100%;
        height: auto;
        margin-top: 30px;

        .feature-content {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            position: relative;

            .feature-item {
                width: 32.9%;
            }
        }
    }

    .site-main {
        padding-top: 80px;

        &.search {
            padding-top: 0;
        }
    }

    .more{
        margin: 50px 0;
        .more-btn{
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 20px;
            margin: 0 auto;
            cursor: pointer;
            &:hover{
                color: #8fd0cc;
                border: 1px dashed #8fd0cc;
            }
        }
    }
    .question-number-title{
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2B2B2B;
        margin-bottom:50px;
    }
    .question-number-submit-btn-box{
        text-align: center;
        position: absolute;
        cursor: pointer;
        // bottom: 0;
        width: 100%;
    }

    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }

    }

    .mid-div{
        height:30px;
    }

    @media (max-width: 1400px) {
        .question-index-box{
            min-height: 78vh;
        }

        .work-box-card{
            height:87vh;
        }
    }

    /******/
</style>
